import { useTranslation } from 'react-i18next';
import {
  hasRoutineQuoteStatus,
  quoteStatusLabelKey,
  type NegotiatingQuote,
} from './quoteNegotiation';

export function QuoteStatusLabel({
  quote,
  className,
}: Readonly<{ quote: NegotiatingQuote; className: string }>) {
  const { t } = useTranslation('rfq-view');
  if (hasRoutineQuoteStatus(quote)) return null;
  return <span className={className}>{t(quoteStatusLabelKey(quote))}</span>;
}
